import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../../shared/print-card-content.component';
import { TrueNorthLandscapeCardStackContentViewModel } from './true-north-landscape-card-stack-content-view-model';

@Component({
  selector: 'app-true-north-landscape-card-stack-content',
  templateUrl: './true-north-landscape-card-stack-content.component.html',
  styleUrls: ['./true-north-landscape-card-stack-content.component.scss'],
  providers: [TrueNorthLandscapeCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TrueNorthLandscapeCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: TrueNorthLandscapeCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
